module.exports = __webpack_public_path__ + "img/trial3-1.70f25f82.png";